import { Box, styled, Theme } from '@mui/material';
import { palette } from 'view/themes/palette';

export const Wrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
    height: 'auto',
    width: '100%',
    gap: '24px',
    backgroundColor: palette.background.general,
    position: 'relative',

    '> form': {
      width: '80%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px',

      [theme.breakpoints.down('desktop')]: {
        width: '95%',
      },

      [theme.breakpoints.down('tablet')]: {
        width: '100%',
        gap: '0px',
      },
    },

    [theme.breakpoints.down('tablet')]: {
      padding: 0,
      backgroundColor: palette.white,
      gap: '0px',
    },
  };
});

export const MainContentWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    /* position: 'relative', */
    paddingBottom: '24px',
    display: 'flex',
    gap: '24px',
    alignItems: 'flex-start',

    /* [theme.breakpoints.down('desktop')]: {
      width: '95%',
    },
*/
    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      padding: '0 16px 32px 16px',
      gap: '32px',
    },
  };
});

export const SearchContainer = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    minHeight: '100px',
    borderRadius: '32px',
    padding: '32px',
    backgroundColor: palette.white,
    display: 'flex',
    alignItems: 'center',
    gap: '32px',

    [theme.breakpoints.down('laptop')]: {
      gap: '10px',
    },

    button: {
      width: '144px',
      height: '40px',
      minHeight: '40px',
    },

    /* [theme.breakpoints.down('desktop')]: {
      width: '95%',
    },
*/
    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      padding: '16px',
      minHeight: 'auto',
    },
  };
});
